import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage26.module.css";

export default function LaymanPage26() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>FORCES OF MARS</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_yin_yang_block_main_wrpper}>
                <div className={`${styles.mars_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block1_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block1_img.webp`}/> 
                  </div>
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>
                          The Martial Symphony: Unraveling the Forces of Mars in
                          the Cosmic Tapestry
                        </h2>
                      </div>
                      <p>
                        Mars, a celestial force within the intricate weave of
                        <Link href="https://www.divineinfinitebeing.com"> the School of Divine Infinite Being</Link> method and
                        Archetypal Astrology, emerges as a dynamic and potent
                        influence, epitomizing extreme focus, active energy, and
                        the relentless impulse toward activity. Beyond its
                        astronomical significance, Mars is a force of war and a
                        refining agent, a cosmic warrior blasting through
                        illusions and setting the pace toward conquest.
                      </p>

                      <p>
                        In the annals of history and mythology, Mars has been
                        revered as the god of war, an archetype mirrored in the
                        cosmic forces it represents. This planetary warrior is
                        not merely a force of conflict but a guiding light in
                        the quest for knowledge and truth. Mars bestows upon its
                        seekers the courage to peer fearlessly into the unknown,
                        pushing boundaries in a relentless pursuit of
                        understanding.
                      </p>
                      <p>
                        The forces of Mars manifest as extreme focus and the
                        ability to enter the famous <span><i>"Flow State,"</i></span> a
                        zone where exerted willpower becomes a physical
                        manifestation of the Mars energy. This force is the
                        executive function that propels individuals forward,
                        setting them on a path of conquest and accomplishment.
                      </p>
                      <p>
                        Mars shares a profound relationship with the physical
                        world, emphasizing effort, stamina, and resilience. It
                        embodies the essence of <span><i>"Mind over Matter,"</i></span>{" "}
                        demanding that individuals confront the unadulterated
                        facts of existence. Mars, with its uncompromising
                        energy, cuts through the superfluous, shaking the
                        foundations of individual belief systems and crumbling
                        outworn ideologies. In this process, aggressive feelings
                        may arise as Mars challenges individuals to confront
                        reality head-on.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.mars_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn} `}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block2_img.webp`}/> 
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        The male-centered energies of Mars are penetrating and
                        filled with vigor, reflecting the archetype of a cosmic
                        warrior ready to face any challenge. It is a force that
                        builds resilience and fortitude, pushing individuals to
                        overcome obstacles and emerge victorious in the
                        battlefield of life.
                      </p>

                      <p>
                        As an Archetypal instinct, Mars embodies the{" "}
                        <span><i>"Drive to Master."</i></span> It represents an impulse
                        toward progress rooted in truth, urging individuals to
                        forge ahead in the pursuit of knowledge and
                        understanding. Mars, in its essence, is the cosmic
                        catalyst that propels individuals towards conquest, not
                        only in the external world but also in the internal
                        landscape of self-discovery.
                      </p>

                      <p>
                        In conclusion, Mars is more than a mere astronomical
                        entity; it is a dynamic force that shapes the cosmic
                        symphony, infusing it with the relentless energy of a
                        warrior on a quest for truth. As seekers navigate the
                        cosmic tapestry, Mars stands as a guiding force, urging
                        them to embrace the drive to master, progress in truth,
                        and emerge victorious in the ever-unfolding journey of
                        existence.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.mars_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block3_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block3_img.webp`}/> 
                  </div>
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={`${styles.layman_txt_box_innr} ${styles.bullet_wrapper}`}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>

                      <p>
                        <strong>Occult Forces:</strong> Mars is a significant
                        Occult force within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                        method and Archetypal Astrology, representing potent
                        cosmic energies associated with focus, active energy,
                        and the impulse toward activity.
                      </p>
                      <p>
                        <strong>Force of War:</strong> Mars is traditionally
                        associated with the force of war, symbolizing a cosmic
                        warrior that refines and conquers, blasting through
                        illusions and setting the pace for conquest.
                      </p>
                      <p>
                        <strong>Quest for Knowledge and Truth:</strong> Mars
                        imparts seekers with courage to peer fearlessly into the
                        unknown, making it a force driving the quest for
                        knowledge and truth.
                      </p>

                      <p>
                        <strong>Executive Function and Flow State:</strong> Mars
                        manifests as the executive function, enabling
                        individuals to enter the <span><i>"Flow State,"</i></span>{" "}
                        where exerted willpower becomes a physical
                        manifestation, propelling them forward.
                      </p>

                      <p>
                        <strong>Physical World Embrace:</strong> Mars has a deep
                        relationship with the physical world, emphasizing
                        effort, stamina, and resilience, embodying the essence
                        of <span><i>"Mind over Matter."</i></span>
                      </p>

                      <p>
                        <strong>Cutting Out Uselessness:</strong> Mars acts as a
                        refining agent, cutting out all that is useless,
                        demanding individuals to confront the unadulterated
                        facts of existence.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.mars_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn} `}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block4_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_FORCESON_MARS/as_forces_mars_block4_img.webp`}/> 
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={`${styles.layman_txt_box_innr} ${styles.bullet_wrapper}`}>
                      <p>
                        <strong>Shaking Belief Systems:</strong> Mars can shake
                        the foundations of individual belief systems and crumble
                        outworn ideologies, often leading to aggressive feelings
                        as it challenges individuals to confront reality.
                      </p>
                      <p>
                        <strong>Male-Centered Energies:</strong> The energies of
                        Mars are male-centered, penetrating, and filled with
                        vigor, reflecting the archetype of a cosmic warrior
                        ready to face challenges.
                      </p>

                      <p>
                        <strong>Progress in Truth:</strong> As an Archetypal
                        instinct, Mars embodies the <i>"Drive to Master"</i> and an
                        impulse towards <i>"Progress in Truth,"</i> urging individuals
                        to progress in their understanding and mastery of life.
                      </p>

                      <p>
                        <strong>Resilience Building:</strong> Mars builds
                        resilience and fortitude, pushing individuals to
                        overcome obstacles and emerge victorious in the
                        battlefield of life.
                      </p>

                      <p>
                        <strong>
                          Conquest in External and Internal Realms:
                        </strong>{" "}
                        Mars represents a force of conquest not only in the
                        external world but also in the internal landscape of
                        self-discovery and personal growth.
                      </p>

                      <p>
                        <strong>Relentless Energy:</strong> Mars infuses the cosmic symphony with
                        relentless energy, shaping the dynamic forces that drive
                        individuals forward in the ever-unfolding journey of
                        existence.
                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.green_sec_cmn_main_wrp} ${styles.veneration_green_wrapper}`}>
            <div className={styles.common_width}>
              <Link href="/rota-the-wheel">
                <div className={styles.green_sec_cmn_sub_wrp}>
                  <h1>
                    The Astrological Tarot association for Mars is The Tower.
                    <br /> See our alchemical ROTA here.
                  </h1>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* 
            <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_mars/layman_page26_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_mars/layman_page26_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_mars/layman_page26_block3_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_mars/layman_page26_block4_demo_img_nw_d.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_mars/layman_page26_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
    </>
  );
}
